import { Injectable } from '@angular/core';
import { isNullOrUndefined } from '@sla-ng/core';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { IProductionVersion } from '../../../models/production-version.model';
import { IProductionVersionFilter } from '../../../models/util/production-version-filter.model';
import { TransactionalDataResource } from '../../../resources/transactional-data.resource';
import { IProductionVersionState } from './production-version.state.model';

let _state: IProductionVersionState = {
    recipe: { entries: [], exits: [] },
    filter: {
        textFilter: '',
        typeFilters: {
            endProductsOnly: false,
            semiProductsOnly: false,
            entryArticleNr: null,
        },
    },
    productionVersions: [],
    selectedProductionVersion: null,
    isLoading: false,
};

@Injectable({
    providedIn: 'root',
})
export class ProductionVersionFacade {
    protected store$: BehaviorSubject<IProductionVersionState> = new BehaviorSubject<IProductionVersionState>(_state);

    constructor(private myTransactionalDataResource: TransactionalDataResource) {
    }

    // fetchProductionVersions with no/one filter on end-/semiProducts
    public async fetchProductionVersions(onlyEndProducts: boolean, onlySemiProducts: boolean, entryArticleNr: string): Promise<void> {
        this.setIsloading(true);
        const productionVersions: IProductionVersion[] = await firstValueFrom(this.myTransactionalDataResource.getProductionVersions(onlyEndProducts, onlySemiProducts, entryArticleNr)).catch(() => []);
        this.updateState({ ..._state, productionVersions });
        this.setIsloading(false);
    }

    public async setSelectedProductionVersion(productionVersionId: number): Promise<void> {

        if (_state.selectedProductionVersion?.id === productionVersionId) {
            return;
        }

        this.setIsloading(true);
        let selectedProductionVersion = _state.productionVersions.find(pV => pV.id === productionVersionId);
        if (isNullOrUndefined(selectedProductionVersion)) {
            await this.fetchProductionVersions(false, false, null);
            this.setIsloading(true);
        }
        selectedProductionVersion = _state.productionVersions.find(pV => pV.id === productionVersionId);

        if (!isNullOrUndefined(selectedProductionVersion)) {
            const recipe = await firstValueFrom(this.myTransactionalDataResource.getRecipe(selectedProductionVersion.id)).catch(() => null);
            this.updateState({ ..._state, recipe, selectedProductionVersion });
        }
        this.setIsloading(false);

    }

    public subState(): Observable<IProductionVersionState> {
        return this.store$.asObservable();
    }

    public setFilterState(filter: IProductionVersionFilter): void {
        this.updateState({ ..._state, filter });
    }

    public getStateSnapshot(): IProductionVersionState {
        return this.store$.value;
    }

    private updateState(state: IProductionVersionState): void {
        this.store$.next(_state = state);
    }

    private setIsloading(isLoading: boolean): void {
        this.updateState({ ..._state, isLoading });
    }
}
